import React from 'react';
import ReactDOM from 'react-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { Provider } from "react-redux";
import gommeStore from "../../stores/gomme-store.js";

import {
  UPDATE_SOMETHING
} from "../../stores/action-types.js"; 

import Backdrop from '@material-ui/core/Backdrop';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { makeStyles } from '@material-ui/core/styles';
import { Localize } from './localize';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Ribbon = props => {

  //const texts = [
  //  "<span style=\"vertical-align:middle;\">Acquista i tuoi prodotti con la <strong>garanzia danni accidentali</strong> e viaggia sereno.</span>",
  //  "<span style=\"vertical-align:middle;\">Scegli un kit con cerchi <strong>AEZ, DOTZ e DEZENT</strong>, il montaggio kit è Gratuito!</span>"
  //];

  //const images = [
  //  "<i class=\"fas fa-shield-alt\" data-fa-transform=\"grow-12\"></i>",
  //  null
  //];

  //const delay = 6;

  //const [next, setNext] = useState(new Date().setSeconds(new Date().getSeconds() + (window.HelloBars || {delay: 6}).delay));

  //const [index, setIndex] = useState(0);

  //useEffect(() => {
  //  const timer = setTimeout(() => {
  //    if (isOpenHelloBar && (next < Date.now())) {
  //      setIndex((index + 1) >= (window.HelloBars || { texts: [] }).texts.length ? 0 : (index + 1));

  //      setNext(new Date().setSeconds(new Date().getSeconds() + (window.HelloBars || { delay: 6 }).delay));
  //    }
  //  }, (window.HelloBars || { delay: 6 }) * 1000);

  //  return () => clearTimeout(timer);
  //});

  const [count, setCount] = useState((window.HelloBars || { delay: 6 }).delay);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isOpenHelloBar) {
        if (count < 0) {
          var changeIndex = (index + 1) >= (window.HelloBars || { texts: [] }).texts.length ? 0 : (index + 1);

          setIndex(changeIndex);

          if ((window.HelloBars.callbacks != null) && (window.HelloBars.callbacks.length > changeIndex) && (window.HelloBars.callbacks[changeIndex] != null)) {
            setTimeout(function () {
              window.HelloBars.callbacks[changeIndex]();
            }, 500);
          }

          setCount((window.HelloBars || { delay: 6 }).delay);
        }
        else {
          setCount(count - 1);
        }
      }
    }, 1000);

    return () => clearTimeout(timer);
  });


  //const [index, setIndex] = useState(0);

  //setTimeout(() => {
    
  //  alert(messageRef.current);
  //}, 2000);

  const classes = useStyles();

  const ribbon = useSelector(state => state.shared.ribbon);
  const isOpenHelloBar = (ribbon && ribbon.HelloBar === true) ? false : true;
  const isOpenPopUp = (ribbon && ribbon.PopUp === true);

  const dispatch = useDispatch();

  // console.log("!!!ribbon", ribbon);

  const handleClose = (e) => {
    e.preventDefault();
    var ribbon = { HelloBar: true, PopUp: false };

    dispatch({
      type: UPDATE_SOMETHING, data: {
        ribbon: ribbon
      }
    });
  };

  const handleOpen = (e) => {
    e.preventDefault();
    var ribbon = { HelloBar: true, PopUp: true };

    dispatch({
      type: UPDATE_SOMETHING, data: {
        ribbon: ribbon
      }
    });
  };

  const handleClick = (e, href) => {
    e.preventDefault();
    handleClose();
    console.log("handleClick",e);

    setTimeout(() => {
      window.location.href = href;
    }, 250);
  };

  var ret = null;

  if (isOpenPopUp) {
    ret = (
      <Backdrop className={classes.backdrop} open={isOpenPopUp}>
        <ClickAwayListener onClickAway={e=>handleClose(e)}>
          <div className="box">
            <div className="ribbon ribbon-top-left"><span>Coronavirus</span></div>
            <div className="ribbon-title">{Localize.L("Se hai bisogno dei nostri prodotti ci siamo.")}</div>
            <div>
              {Localize.L("Nel rispetto di tutte le disposizioni emanate dal Governo, abbiamo messo in atto le misure opportune al fine di proteggere i nostri dipendenti, partners, clienti e fornitori.") }
            </div>
            <div className="ribbon-p"><strong>{Localize.L("Le date di consegna")}</strong> {Localize.L("indicate sul sito sono aggiornate ed attuali.")}</div>
            <div className="ribbon-p">
              {Localize.L("I nostri dipendenti continuano a dare supporto via mail e telefono lavorando in")} <strong>smartworking</strong>.
            {Localize.L("I nostri centri logistici lavorano su")} <strong>{Localize.L("turni")}</strong> {Localize.L("in modo da limitare i contatti e non interrompere il servizio.")}
        </div>
            <div className="ribbon-p">
              {Localize.L("Se sei in emergenza")}, <a href="/kit-ruote-complete" onClick={e => handleClick(e, "/kit-ruote-complete")}><i className="fas fa-info-circle"></i><strong>{Localize.L("acquista cerchi e pneumatici")}</strong></a>, {Localize.L("te li spediremo già installati ed equilibrati al tuo domicilio")}, <a href="/kit-ruote-complete" onClick={e => handleClick(e, "/kit-ruote-complete")}><strong>{Localize.L("potrai installarli autonomamente senza recarti dal gommista")}</strong></a>.
        </div>
            <div className="ribbon-footer">
              <button className="btn btn-light" onClick={e => handleClose(e)}>{ Localize.L("Chiudi")}</button>
            </div>
          </div>
        </ClickAwayListener>
      </Backdrop>
    );
  }

  if (isOpenHelloBar) {
    ret = <HelloBar_Good handleOpen={handleOpen} handleClose={handleClose} text={(window.HelloBars || { texts: [""] }).texts[index]} image={(window.HelloBars || { images: [] }).images[index]} />
    //ret = (
    //  <div className="hello-bar-wrapper">
    //    <div className="container">
    //      <div className="row">
    //        <div className="col">
    //          <a href="#" onClick={e=>handleOpen(e)} ><i className="fas fa-info-circle" style={{ fontSize: "2rem", verticalAlign: "middle" }}></i> <span style={{ verticalAlign: "middle" }}><span>Covid-19</span>, le date di consegna indicate sono aggiornate ed attuali.</span></a>
    //        </div>
    //        <div className="col-2" style={{textAlign: "right"}}>
    //          <a href="#" onClick={e=>handleClose(e)}>
    //            <span><i className="far fa-times-circle" style={{ fontSize: "2rem", verticalAlign: "middle" }}></i> <span style={{ verticalAlign: "middle" }}>Chiudi</span></span>
    //          </a>
    //        </div>
    //      </div>
    //    </div>
    //  </div>
    //);
  }

  return ret;
}

function HelloBar_Good({ handleOpen, handleClose, text, image }) {
  return (
    <div className="hello-bar-wrapper-good">
      <div className="container">
        <div className="row">
          <div className="col-10" style={{ position: "relative", lineHeight: "30px" }}>
            <div style={{ position: "absolute", top: 3, left: 0, zIndex: 99, color: "white" }}>
              <span dangerouslySetInnerHTML={{ __html: image }}>
              </span>
            </div>
            <div dangerouslySetInnerHTML={{ __html: text }} href="#" style={{ marginLeft: 25, color: '#fff' }}>
            </div>
          </div>
          <div className="col-2" style={{ textAlign: "right", lineHeight: "30px" }}>
            <a href="#" onClick={e => handleClose(e)}>
              <span><i className="fa fa-times-circle" style={{ fontSize: "2rem", verticalAlign: "middle" }}></i> <span style={{ verticalAlign: "middle" }}>{Localize.L("Chiudi")}</span></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function HelloBar_Xmas({ handleOpen, handleClose }) {
  return (
    <div className="hello-bar-wrapper-xmas">
      <div className="container">
        <div className="row">
          <div className="col-10" style={{ position: "relative" }}>
            <div style={{ position: "absolute", top: -5, left: 0, zIndex: 99 }}>
              <img src="/images/xmas-snowman.png" style={{ height: 50 }} />
            </div>
            <div style={{ position: "absolute", top: -5, right: 0, zIndex: 99 }}>
              <img src="/images/xmas-deco.png" style={{ height: 50 }} />
            </div>
            <a href="#" style={{ marginLeft: 25 }}>
              <span style={{ verticalAlign: "middle" }}><span style={{ fontFamily: "Open Sans", fontSize: 24 }}>{Localize.L("Buone feste!")}</span>, {Localize.L("da tutto lo staff")} <span style={{ textDecoration: "italic" }}>{Localize.L("di cerchigomme.it")}</span></span>
            </a>
          </div>
          <div className="col-2" style={{ textAlign: "right" }}>
            <a href="#" onClick={e => handleClose(e)}>
              <span><i className="fa fa-times-circle" style={{ fontSize: "2rem", verticalAlign: "middle" }}></i> <span style={{ verticalAlign: "middle" }}>{Localize.L("Chiudi")}</span></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function HelloBar_variant_3({ handleOpen, handleClose }) {
  return (
    <div className="hello-bar-wrapper-3">
      <div className="container">
        <div className="row">
          <div className="col-10">
            <a href="/offerta-pneumatici-michelin?adid=PROMO202011_HELLO">
              <span style={{ verticalAlign: "middle" }}>{Localize.L("Buoni")} <span style={{ fontFamily: "Open Sans", color: "RGB(252,229,0)", fontWeight: 700 }}>amazon</span> {Localize.L("fino a 40 euro per l'acquisto di 4 pneumatici")} <span style={{ fontFamily: "Open Sans", color: "RGB(252,229,0)", fontWeight: 700 }}>Michelin</span>.</span>
            </a>
          </div>
          <div className="col-2" style={{ textAlign: "right" }}>
            <a href="#" onClick={e => handleClose(e)}>
              <span><i className="fa fa-times-circle" style={{ fontSize: "2rem", verticalAlign: "middle" }}></i> <span style={{ verticalAlign: "middle" }}>{Localize.L("Chiudi")}</span></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ribbon;

var ribbon = document.getElementById('covid-19-ribbon');
if (ribbon) {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <Ribbon />
    </Provider>,
    ribbon
  );
}
